const CrownIcon = () => {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" className="sc-PBEJI fthtoW">
        <path fill="#FFD700" d="m14.244 11.5-.256 1.113A.5.5 0 0 1 13.5 13h-10a.5.5 0 0 1-.487-.387L2.756 11.5zm1.244-5.388L14.475 10.5H2.525L1.513 6.112a.5.5 0 0 1 .735-.546l3.095 1.768 2.74-4.111a.5.5 0 0 1 .812-.03l3.214 4.133 2.614-1.742a.501.501 0 0 1 .765.528"></path>
      </svg>
    </div>
  );
};

export default CrownIcon;
